import { useQuery } from "urql";

import {
  GetCollectorsDocument,
  UserRoleFilterOptions,
  UserStatusFilterOptions,
} from "../../../graphql/generated.ts";

export const useRRAssignees = () => {
  const variables = {
    filter: {
      role: {
        in: [UserRoleFilterOptions.RrManager, UserRoleFilterOptions.RrOfficer],
      },
      status: { equals: UserStatusFilterOptions.Active },
    },
  };
  return useQuery({
    query: GetCollectorsDocument,
    variables,
  });
};
